import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
export interface DialogCourseData {
	title: string;
	bundle: string;
	totalEnrollments: number;
	users: {
		name: string;
		email: string;
		enrolledDate: string;
		progress: number;
		initials: string;
	}[];
}
@Component({
	selector: 'app-dialog-enrollments',
	standalone: true,
	imports: [CommonModule, MatTooltipModule],
	templateUrl: './dialog-enrollments.component.html',
	styleUrl: './dialog-enrollments.component.scss'
})
export class DialogEnrollmentsComponent {


	@Input() course: DialogCourseData | null = null;
	@Input() loading = false;
	@Input() currentPage!: number;
    @Input() totalPages!: number;

	@Output() close = new EventEmitter<void>();
	@Output() pageChange = new EventEmitter<number>();

	closeModal() {
		this.close.emit();
	}

	changePage(page: number) {
		this.pageChange.emit(page);
	}

}
